module.exports = __webpack_public_path__ + "img/mountain_sm.906ab202.png";